import { redirect } from "react-router-dom";
import { getFeatureFlag } from "src/app/featureFlags";
import { INDEX_ROUTES } from "src/app/constants";

/**
 * Loader that gates the Form Studio route behind the enableFormStudio feature flag.
 * Redirects to the admin index when the flag is disabled or on error.
 */
export const loader = async () => {
  try {
    const isEnabled = await getFeatureFlag("enableFormStudio");
    if (!isEnabled) {
      return redirect(INDEX_ROUTES.ADMIN);
    }
    return null;
  } catch {
    return redirect(INDEX_ROUTES.ADMIN);
  }
};
